import { ThemeProvider as NextThemesProvider } from 'next-themes'
import type { ReactNode } from 'react'

/**
 * MES Design System is dark-first — `:root` in `tokens.bundle.css` already
 * declares dark surface stack + lime accent. `next-themes` flips
 * `<html data-theme>` between `dark` (default) and `light` (opt-in via
 * `html[data-theme="light"]` overrides in tokens.bundle.css).
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="data-theme"
      defaultTheme="dark"
      enableSystem={false}
      disableTransitionOnChange={false}
      themes={['light', 'dark']}
    >
      {children}
    </NextThemesProvider>
  )
}
